import React, { FC, useEffect, useState } from 'react'
import { MaterialExpo, MaterialExpoPost } from '../../../clients/api_client'
import OpenTitleCard from '../../../components/card/open_title_card'
import ImageModal from '../../../components/modal/image_modal'

type Props = {
  materialExpo: MaterialExpo
}

const MaterialExpoCard: FC<Props> = (props) => {
  const [posts, setPosts] = useState<MaterialExpoPost[]>([])
  const [selectPost, setSelectPost] = useState<MaterialExpoPost | null>(null)

  useEffect(() => {
    if (props.materialExpo.expoPosts.length > 0) {
      setPosts(props.materialExpo.expoPosts)
      setSelectPost(props.materialExpo.expoPosts[0])
    }
  }, [props.materialExpo])

  if (selectPost === null || posts.length === 0) {
    return <></>
  }

  return (
    <OpenTitleCard title="画像" defaultOpen={true}>
      <div>
        <div className="py-6">
          {selectPost.content !== null && (
            <div className="mb-6 whitespace-break-spaces">
              {selectPost.content}
            </div>
          )}
          <ImageModal
            imageUrl={selectPost.imageUrl}
            trigger={
              <img src={selectPost.imageUrl} className="w-full shadow-lg mb-6 cursor-pointer" />
            }
          />
          {posts.length > 1 && (
            <div className="flex items-center flex-wrap">
              {posts.map((post, index) => (
                <div
                  onClick={() => {
                    setSelectPost(post)
                  }}
                  className={`mr-4 mb-2 underline ${
                    post.title === selectPost.title
                      ? 'text-main-blue'
                      : 'text-main-lightGray cursor-pointer'
                  }`}
                  key={`post-${index}`}
                >
                  {post.title}
                </div>
              ))}
            </div>
          )}
        </div>
        {(selectPost.sourceSiteName !== null ||
          selectPost.sourceSiteUrl !== null) && (
          <div className="w-full py-6 border-t border-main-lightGray text-main-lightGray text-sm text-right">
            {selectPost.sourceSiteName !== null && (
              <p className="leading-normal">
                引用元：{selectPost.sourceSiteName}
              </p>
            )}
            {selectPost.sourceSiteUrl !== null && (
              <a
                href={selectPost.sourceSiteUrl}
                target="_blank"
                rel="noreferrer"
                className="leading-normal underline"
              >
                {selectPost.sourceSiteUrl}
              </a>
            )}
          </div>
        )}
      </div>
    </OpenTitleCard>
  )
}

export default MaterialExpoCard
